"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
var DATA_ACTION;
(function (DATA_ACTION) {
    DATA_ACTION["remove"] = "remove";
    DATA_ACTION["add"] = "add";
    DATA_ACTION["reorder"] = "reorder";
})(DATA_ACTION = exports.DATA_ACTION || (exports.DATA_ACTION = {}));
/**
 * @hidden
 */
exports.dataReducer = function (state, action) {
    switch (action.type) {
        case DATA_ACTION.add:
            // TODO v2
            break;
        case DATA_ACTION.remove:
            return state.filter(function (i) { return i[action.valueField] !== action.payload; });
        case DATA_ACTION.reorder:
            // TODO v2
            break;
        default:
            return state;
    }
};
//# sourceMappingURL=data-reducer.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-buttons@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-buttons/dist/npm/Chip/data-reducer.js
// module id = 281
// module chunks = 0